import React from 'react';

import footerImage from 'assets/images/FOOTER-NUEVO-CHINOIN.png';

const GeneralFooter = () => (
  <footer className="general-footer" aria-label="Pie de página">
    <img
      className="footer-image"
      src={footerImage}
      alt="Desarrollado por Intersistemas, S.A. de C.V."
    />
  </footer>
);

export default GeneralFooter;
